import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17bfb0cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "알림", -1))
const _hoisted_5 = { class: "modal_close" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, " 탈퇴하시겠습니까? ", -1))
const _hoisted_7 = { class: "wrap_button" }
const _hoisted_8 = {
  key: 1,
  class: "modal-overlay"
}
const _hoisted_9 = { class: "modal" }
const _hoisted_10 = { class: "modal-header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "알림", -1))
const _hoisted_12 = { class: "modal_close" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, " 수정하시겠습니까? ", -1))
const _hoisted_14 = { class: "wrap_screen" }
const _hoisted_15 = { class: "status_bar" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 내 정보 수정 ", -1))
const _hoisted_17 = { class: "wrap_chat_screen" }
const _hoisted_18 = { class: "form_box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "profilePicture" }, "프로필 사진 선택", -1))
const _hoisted_20 = { class: "image-list" }
const _hoisted_21 = ["src", "alt", "onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "아이디", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nickname" }, "닉네임", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "변경할 비밀번호", -1))

import {
  ref,
  onMounted,
  onUnmounted,
  computed,
} from 'vue';
import { notification as AntNotification } from 'ant-design-vue/lib/components';
import type { SelectProps } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import {
  iAvatar,
  iUserRoom,
} from '@interface/chat';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { pushPage } from '@utils/route.helper';
import router from '@router';
import { errorType } from '@interface/error';
import {
  putProfilePicture,
  getSignedUserInfo,
  putNickName,
} from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyInfo',
  setup(__props) {

const userData = userStore();
const name = ref('');
const email = ref('');
const changePassword = ref('0000000');
const userName = ref('');
const showOutModal = ref(false);
const showEditModal = ref(false);
const selectedPicture = ref<string | null>(null);
const userDetail = ref<any>({});
const selectedFileName = ref('');

const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};

const getUserDetail = async () => {
  const result = await getSignedUserInfo();
  userDetail.value = result.data;
  userName.value = result.data.nick_name;
};

// 샘플 이미지 목록
const sampleImages = [
  {
    id: 1,
    name: '사진 1',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_fox.png'),
  },
  {
    id: 2,
    name: '사진 2',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_dog.png'),
  },
  {
    id: 3,
    name: '사진 3',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_bear.png'),
  },
  {
    id: 4,
    name: '사진 4',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_unicorn.png'),
  },
  {
    id: 5,
    name: '사진 5',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_tiger.png'),
  },
  {
    id: 6,
    name: '사진 6',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_shark.png'),
  },
  {
    id: 7,
    name: '사진 7',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_koala.png'),
  },
  {
    id: 8,
    name: '사진 8',
    // eslint-disable-next-line global-require
    url: require('@assets/emoji_lion.png'),
  },
];

const selectPicture = (url: string) => {
  selectedPicture.value = url;
  const fileName = url.split('/').pop();
  const fileNameWithoutHash = fileName.replace(/\.\w+\./, '.');
  selectedFileName.value = fileNameWithoutHash;
  console.log(selectedPicture.value);
};

const closeOutModal = () => {
  showOutModal.value = false;
};

const openOutModal = () => {
  showOutModal.value = true;
};

const closeEditModal = () => {
  showEditModal.value = false;
};

const openEditModal = () => {
  showEditModal.value = true;
};

const editInfo = async () => {
  const nickparam = { nick_name: userName.value };
  const profile = { profile: selectedFileName.value };
  try {
    if (selectedFileName.value !== '') {
      await putProfilePicture(profile);
    }
    await putNickName(nickparam);
    await closeEditModal();
    router.go(0);
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  await getUserDetail();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showOutModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  onClick: closeOutModal
                })
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "button_okay",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteInfo && _ctx.deleteInfo(...args)))
              }, " 탈퇴 "),
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: closeOutModal
              }, " 취소 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showEditModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  onClick: closeEditModal
                })
              ])
            ]),
            _hoisted_13,
            _createElementVNode("div", { class: "wrap_button" }, [
              _createElementVNode("div", {
                class: "button_okay",
                onClick: editInfo
              }, " 수정 "),
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: closeEditModal
              }, " 취소 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_font_awesome_icon, {
          class: "chevron",
          icon: "fa-solid fa-bars",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showMobileMenu()))
        }),
        _hoisted_16
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("ul", _hoisted_20, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sampleImages, (sampleImage) => {
                return _createElementVNode("li", {
                  key: sampleImage.id
                }, [
                  _createElementVNode("img", {
                    src: sampleImage.url,
                    alt: sampleImage.name,
                    class: _normalizeClass({ selected: sampleImage.url === selectedPicture.value }),
                    onClick: ($event: any) => (selectPicture(sampleImage.url))
                  }, null, 10, _hoisted_21)
                ])
              }), 64))
            ]),
            _hoisted_22,
            _createElementVNode("input", {
              class: "disabled",
              disabled: "",
              type: "text",
              readonly: "",
              value: userDetail.value.user_id ? userDetail.value.user_id : ''
            }, null, 8, _hoisted_23),
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userName).value = $event)),
              type: "text",
              name: "nickname",
              required: ""
            }, null, 512), [
              [_vModelText, userName.value]
            ]),
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((changePassword).value = $event)),
              class: "disabled",
              disabled: "",
              type: "password",
              name: "password",
              required: ""
            }, null, 512), [
              [_vModelText, changePassword.value]
            ]),
            _createElementVNode("div", { class: "wrap_button" }, [
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: openOutModal
              }, " 탈퇴하기 "),
              _createElementVNode("div", {
                class: "button_okay",
                onClick: openEditModal
              }, " 수정하기 ")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})